// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const SalesLeadStateValues = ["OPEN", "DISCARDED", "WON", "LOST"] as const;

export type SalesLeadState = (typeof SalesLeadStateValues)[number];

export const getSalesLeadStateLabels = () => ({
	OPEN: t("open_state"),
	DISCARDED: t("discarded"),
	WON: t("won"),
	LOST: t("lost"),
});

export const getSalesLeadStateLabel = (value: SalesLeadState): string => {
	return getSalesLeadStateLabels()[value];
};
